import React, { FC } from 'react'

const Form: FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <form>{children}</form>
}

export default Form
